export default {
  'Choose File': 'Bestand kiezen',
  'Please paste a URL': 'Alstublieft plak een URL',
  'Loading': 'Belading',
  'Analyzing': 'Analyseren',
  'Try a sample': 'Probeer een monster',
  'Sorry, error occurs when analyzing the URL.': 'Sorry, fout optreedt bij het analyseren van de URL.',
}